import { Injectable } from '@angular/core';
import { getFirebaseBackend } from '../../authUtils';
import { User, UserDetail } from '../models/auth.models';

@Injectable({ providedIn: 'root' })

export class AuthenticationService {
    user: User;
    userDetail: UserDetail;
    constructor() {
    }
    /**
     * Returns the current user
     */
    public currentUser(): User {
        return getFirebaseBackend().getAuthenticatedUser();
    }

    /**
     * Returns the current detail user
     */
    public getDetailUser(): UserDetail {
        return getFirebaseBackend().getDetailUser();
    }

    /**
     * Returns the current client
     */
    public getActiveClient() {
        return getFirebaseBackend().getActiveClient();
    }

    /**
     * Returns the current company
     */
    public getActiveCompany() {
        return getFirebaseBackend().getActiveCompany();
    }

    /**
     * Returns set active company
     */
    public setDetailUser(payload: any) {
        return getFirebaseBackend().setDetailUser(payload);
    }
    public setTokenUser(payload: any) {
        return getFirebaseBackend().setTokenUser(payload);
    }
    public setAccessToken(payload: any) {
        return getFirebaseBackend().setAccessToken(payload);
    }
    public setAksesUser(payload: any) {
        return getFirebaseBackend().setAksesUser(payload);
    }
    public setFotoProfil(payload: any) {
        return getFirebaseBackend().setFotoProfil(payload);
    }

    public setTutorial(payload: any, key: any) {
        return getFirebaseBackend().setTutorial(payload,key );
    }

    /**
     * Performs the auth
     * @param email email of user
     * @param password password of user
     */
    login(email: string, password: string) {
        return getFirebaseBackend().loginUser(email, password).then((response: any) => {
            const user = response;
            return user;
        });
    }
    loginWithoutSecureToken(email: string, password: string) {
        return getFirebaseBackend().loginUserWithoutSecureToken(email, password).then((response: any) => {
            const user = response;
            return user;
        });
    }
    loginWithGoogle() {
        return getFirebaseBackend().loginWithGoogle().then((response: any) => {
            const user = response;
            return user;
        });
    }

    /**
     * Performs the register
     * @param email email
     * @param password password
     */
    register(email: string, password: string) {
        return getFirebaseBackend().registerUser(email, password).then((response: any) => {
            const user = response;
            return user;
        });
    }

    /**
     * Reset password
     * @param email email
     */
    resetPassword(email: string) {
        return getFirebaseBackend().forgetPassword(email).then((response: any) => {
            const message = response.data;
            return message;
        });
    }

    /**
     * Logout the user
     */
    logout() {
        // logout the user
        return getFirebaseBackend().logout();
    }

    /**
     * Check if user tipe is 'admin' or 'pic'
     */
    isAdminPic(): boolean {
        const userDetail = this.getDetailUser();
        return userDetail?.tipe === 'admin' || userDetail?.tipe === 'pic';
    }
}

